// BASE
exports.white = '#FFF';
exports.black = '#000';
exports.gray = '#8F8F8F';
exports.tuna = '#383B41';

exports.transparent = 'transparent';
